import { Formik } from 'formik';
import * as yup from "yup";
import { Box, Button, Dialog, DialogContent, TextField, Typography } from '@mui/material';

function ChangePasswordDialog({ targetUser, dialogOpen, handleClose, handleFormSubmit }) {

    var initialValues = {
        newPassword: "",
    };

    var validationObject = {
        newPassword: yup.string().min(6, "Password must be at least 6 characters").required("Field is required"),
    }

    const passwordSchema = yup.object().shape(validationObject);

    return (
        <Dialog
            sx={{ margin: "0 auto" }} open={dialogOpen}
            onClose={handleClose}>
            <Box m="20px" textAlign="center">
                <Typography variant='h3'>
                    Change User Password
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={(values) => {
                            handleFormSubmit(targetUser.firebase_id, values.newPassword);
                        }}
                        initialValues={initialValues}
                        validationSchema={passwordSchema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="New Password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    name={"newPassword"}
                                    value={values.newPassword}
                                    //dont show recomendation
                                    autoComplete="off"
                                    error={!!touched.newPassword && !!errors.newPassword}
                                    helperText={touched.newPassword && errors.newPassword}
                                    sx={{ gridColumn: "span 2", marginTop: "20px" }}
                                />
                                <Box display="flex" justifyContent="end" m="20px 0px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained" onClick={() => console.log(errors)}>
                                        <Typography variant='h5'>Save</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog >
    )
}

export default ChangePasswordDialog